// extracted by mini-css-extract-plugin
export default {"storybrainResets":"_resets_storybrainResets__+c7Q6"};